import {
  ADD_ITEM_CATEGORY,
  ADD_ITEM_GROUP,
  ADD_ITEM_TYPE,
  ADD_MANUFACTURER,
  ADD_SHIPPING_TYPE,
  ADD_TAX_COMBINATION,
  ADD_TAX_TYPE,
  ADD_UOM,
  ADD_UOM_GROUP,
  ALTERNATIVE_ITEMS_IMPORT,
  ALTERNATIVE_ITEMS_LIST,
  CURRENT_PRINTPREFERENCE,
  DELETE_ALTERNATIVE_TRANSACTION,
  DELETE_ITEM_CATEGORY,
  DELETE_ITEM_GROUP,
  DELETE_ITEM_TYPE,
  DELETE_MANUFACTURER,
  DELETE_SHIPPING_TYPE,
  DELETE_TAX_COMBINATION,
  DELETE_TAX_COMBINATION_ITEM,
  DELETE_TAX_TYPE,
  DELETE_UOM_GROUP,
  DELETE_UOM_GROUP_ITEM,
  DOCUMENT_NUMBERING_LIST,
  DOCUMENT_NUMBERING_SERIES_ADD,
  DOCUMENT_NUMBERING_SERIES_LIST,
  DOCUMENT_NUMBERING_SERIES_UPDATE,
  DOCUMENT_NUMBERING_UPDATE,
  ITEM_CATEGORY_IMPORT,
  ITEM_CATEGORY_LIST,
  ITEM_GROUP_IMPORT,
  ITEM_GROUP_TABLE_LIST,
  ITEM_TYPE_IMPORT,
  ITEM_TYPE_LIST,
  LIST_UOM,
  MANUFACTURERS_IMPORT,
  MANUFACTURERS_TABLE_LIST,
  MAP_ALTERNATIVE_ITEM,
  PAYTM_ADD,
  PAYTM_UPDATE,
  PAYTM_VIEW,
  PHONEPE_ADD,
  PHONEPE_UPDATE,
  PHONEPE_VIEW,
  PINE_LABS_ADD,
  PINE_LABS_UPDATE,
  PINE_LABS_VIEW,
  PRINTPREFERENCE_LIST,
  PRINTPREFERENCE_UPDATE,
  RAZORPAY_ADD,
  RAZORPAY_UPDATE,
  RAZORPAY_VIEW,
  SHIPPING_TYPE_IMPORT,
  SHIPPING_TYPE_TABLE__LIST,
  SMS_ADD,
  SMS_UPDATE,
  SMS_VIEW,
  SMTP_ADD,
  SMTP_UPDATE,
  SMTP_VIEW,
  STORE_GET,
  STORE_UPDATE,
  STRIPE_ADD,
  STRIPE_UPDATE,
  STRIPE_VIEW,
  TAX_COMBINATION_IMPORT,
  TAX_COMBINATION_LIST,
  TAX_TYPE_DROPDOWN,
  TAX_TYPE_IMPORT,
  TAX_TYPE_LIST,
  TCS_TAX_ADD,
  TCS_TAX_DELETE,
  TCS_TAX_IMPORT,
  TCS_TAX_LIST,
  TDS_TAX_ADD,
  TDS_TAX_DELETE,
  TDS_TAX_IMPORT,
  TDS_TAX_LIST,
  TEMPLATE_CREATE,
  TEMPLATE_DELETE,
  TEMPLATE_EDIT,
  TEMPLATE_TABLE,
  TEMPLATE_VIEW,
  UOM_DROPDOWN,
  UOM_GROUP_CALCULATION,
  UOM_GROUP_IMPORT,
  UOM_GROUP_ITEM_IMPORT,
  UOM_GROUP_TABLE_LIST,
  UOM_IMPORT,
  UPDATE_ITEM_CATEGORY,
  UPDATE_ITEM_GROUP,
  UPDATE_ITEM_TYPE,
  UPDATE_MANUFACTURER,
  UPDATE_SHIPPING_TYPE,
  UPDATE_TAX_COMBINATION,
  UPDATE_TAX_TYPE,
  UPDATE_UOM,
  UPDATE_UOM_GROUP,
  WHATSAPP_ADD,
  WHATSAPP_UPDATE,
  WHATSAPP_VIEW,
  BILLING_TYPES,
  CUSTOM_NUMBERING_LIST,
  CUSTOM_NUMBERING_UPDATE,
  CUSTOM_NUMBERING_SERIES_LIST,
  CUSTOM_NUMBERING_SERIES_ADD,
  CUSTOM_NUMBERING_SERIES_UPDATE,
  ROLE_SEARCH,
  ROLE_DELETE,
  ROLE_EDIT,
  ROLE_UPLOAD,
  DEPARTMENR_LIST,
  DEPARTMENT_SEARCH,
  DEPARTMENT_DELETE,
  DEPARTMENT_EDIT,
  DEPARTMENT_UPLOAD,
  ATTACHED_ROLES_DEPARTMENT_CREATE,
  ATTACHED_ROLES_DEPARTMENT_DELETE,
  ROLE_CREATE,
  DEPARTMENT_CREATE,
  PARTY_LIST,
  DRUG_UPLOAD,
  DRUG_EDIT,
  DRUG_DELETE,
  DRUG_CREATE,
  DRUG_SEARCH,
  GENERIC_SEARCH,
  GENERIC_CREATE,
  GENERIC_DELETE,
  GENERIC_EDIT,
  GENERIC_UPLOAD,
  COMPOSITION_SEARCH,
  COMPOSITION_CREATE,
  COMPOSITION_DELETE,
  COMPOSITION_EDIT,
  COMPOSITION_UPLOAD,
  LEAD_SEARCH,
  LEAD_CREATE,
  LEAD_DELETE,
  LEAD_EDIT,
  LEAD_UPLOAD,
  PAYMENT_SEARCH,
  PAYMENT_CREATE,
  PAYMENT_DELETE,
  PAYMENT_EDIT,
  PAYMENT_UPLOAD,
  PACKING_SEARCH,
  PACKING_CREATE,
  PACKING_DELETE,
  PACKING_EDIT,
  PACKING_UPLOAD,
  PACKING_TYPE_SEARCH,
  PACKING_TYPE_CREATE,
  PACKING_TYPE_DELETE,
  PACKING_TYPE_EDIT,
  PACKING_TYPE_UPLOAD,
  CARTON_SEARCH,
  CARTON_CREATE,
  CARTON_DELETE,
  CARTON_EDIT,
  CARTON_UPLOAD,
  PARTY_SEARCH,
  PARTY_CREATE,
  PARTY_DELETE,
  PARTY_EDIT,
  PARTY_UPLOAD,
  PARTY_CATEGORY_SEARCH,
  PARTY_CATEGORY_CREATE,
  PARTY_CATEGORY_DELETE,
  PARTY_CATEGORY_EDIT,
  PARTY_CATEGORY_UPLOAD,
  PARTY_GROUP_SEARCH,
  PARTY_GROUP_CREATE,
  PARTY_GROUP_DELETE,
  PARTY_GROUP_EDIT,
  PARTY_GROUP_UPLOAD,
  COUNTRY_SEARCH,
  COUNTRY_CREATE,
  COUNTRY_DELETE,
  COUNTRY_EDIT,
  COUNTRY_UPLOAD,
  REGION_SEARCH,
  REGION_CREATE,
  REGION_DELETE,
  REGION_EDIT,
  REGION_UPLOAD,
  STATE_SEARCH,
  STATE_CREATE,
  STATE_DELETE,
  STATE_EDIT,
  STATE_UPLOAD,
  DISTRICT_SEARCH,
  DISTRICT_CREATE,
  DISTRICT_DELETE,
  DISTRICT_EDIT,
  DISTRICT_UPLOAD,
  CITY_SEARCH,
  CITY_CREATE,
  CITY_DELETE,
  CITY_EDIT,
  CITY_UPLOAD,
  AREA_SEARCH,
  AREA_CREATE,
  AREA_DELETE,
  AREA_EDIT,
  AREA_UPLOAD,
  SERVER_SEARCH,
  SERVER_CREATE,
  SERVER_DELETE,
  SERVER_EDIT,
  SERVER_UPLOAD,
  SPECIALIZATION_SEARCH,
  SPECIALIZATION_CREATE,
  SPECIALIZATION_DELETE,
  SPECIALIZATION_EDIT,
  SPECIALIZATION_UPLOAD,
  SUB_SPECIAL_SEARCH,
  SUB_SPECIAL_CREATE,
  SUB_SPECIAL_DELETE,
  SUB_SPECIAL_EDIT,
  SUB_SPECIAL_UPLOAD,
  INSURANCE_SEARCH,
  INSURANCE_CREATE,
  INSURANCE_DELETE,
  INSURANCE_EDIT,
  INSURANCE_UPLOAD,
  ADD_CUSTOM_INVOICE,
  UOM_DROPDOWN_NEW,
} from "../types";

/**UOM Setup */
export const uomCreateAction = (data, onSuccess, onError) => {
  return {
    type: ADD_UOM,
    data,
    onSuccess,
    onError,
  };
};

export const uomUpdateAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_UOM,
    data,
    onSuccess,
    onError,
  };
};

export const uomListAction = (data, onSuccess, onError) => {
  return {
    type: LIST_UOM,
    data,
    onSuccess,
    onError,
  };
};
export const uomImportAction = (data, onSuccess, onError) => {
  return {
    type: UOM_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const uomGroupTableListAction = (data, onSuccess, onError) => {
  return {
    type: UOM_GROUP_TABLE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const uomGroupAddAction = (data, onSuccess, onError) => {
  return {
    type: ADD_UOM_GROUP,
    data,
    onSuccess,
    onError,
  };
};

export const uomGroupUpdateAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_UOM_GROUP,
    data,
    onSuccess,
    onError,
  };
};

export const uomGroupDeleteAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_UOM_GROUP,
    data,
    onSuccess,
    onError,
  };
};
export const uomGroupImportAction = (data, onSuccess, onError) => {
  return {
    type: UOM_GROUP_IMPORT,
    data,
    onSuccess,
    onError,
  };
};
export const uomGroupItemImportAction = (data, onSuccess, onError) => {
  return {
    type: UOM_GROUP_ITEM_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const deleteUomGroupItemAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_UOM_GROUP_ITEM,
    data,
    onSuccess,
    onError,
  };
};

export const uomGroupCalculationAction = (data, onSuccess, onError) => {
  return {
    type: UOM_GROUP_CALCULATION,
    data,
    onSuccess,
    onError,
  };
};

export const uomDropDownAction = (data, onSuccess, onError) => {
  return {
    type: UOM_DROPDOWN,
    data,
    onSuccess,
    onError,
  };
};

export const uomDropDownActionnew = (data, onSuccess, onError) => {
  return {
    type: UOM_DROPDOWN_NEW,
    data,
    onSuccess,
    onError,
  };
};

/**Item Setup */

export const itemTypeListAction = (data, onSuccess, onError) => {
  return {
    type: ITEM_TYPE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addItemTypeAction = (data, onSuccess, onError) => {
  return {
    type: ADD_ITEM_TYPE,
    data,
    onSuccess,
    onError,
  };
};

export const updateItemTypeAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_ITEM_TYPE,
    data,
    onSuccess,
    onError,
  };
};

export const deleteItemTypeAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_ITEM_TYPE,
    data,
    onSuccess,
    onError,
  };
};
export const ItemTypeImportAction = (data, onSuccess, onError) => {
  return {
    type: ITEM_TYPE_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const itemCategoryListAction = (data, onSuccess, onError) => {
  return {
    type: ITEM_CATEGORY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addItemCategoryAction = (data, onSuccess, onError) => {
  return {
    type: ADD_ITEM_CATEGORY,
    data,
    onSuccess,
    onError,
  };
};

export const updateItemCategoryAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_ITEM_CATEGORY,
    data,
    onSuccess,
    onError,
  };
};

export const deleteItemCategoryAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_ITEM_CATEGORY,
    data,
    onSuccess,
    onError,
  };
};
export const ItemCategoryImportAction = (data, onSuccess, onError) => {
  return {
    type: ITEM_CATEGORY_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const itemGroupTableListAction = (data, onSuccess, onError) => {
  return {
    type: ITEM_GROUP_TABLE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addItemGroupAction = (data, onSuccess, onError) => {
  return {
    type: ADD_ITEM_GROUP,
    data,
    onSuccess,
    onError,
  };
};

export const updateItemGroupAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_ITEM_GROUP,
    data,
    onSuccess,
    onError,
  };
};

export const deleteItemGroupAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_ITEM_GROUP,
    data,
    onSuccess,
    onError,
  };
};
export const ItemGroupImportAction = (data, onSuccess, onError) => {
  return {
    type: ITEM_GROUP_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

/**Manufacturer setup */
export const manufacturerTableListAction = (data, onSuccess, onError) => {
  return {
    type: MANUFACTURERS_TABLE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addManufacturerAction = (data, onSuccess, onError) => {
  return {
    type: ADD_MANUFACTURER,
    data,
    onSuccess,
    onError,
  };
};

export const updateManufacturerAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_MANUFACTURER,
    data,
    onSuccess,
    onError,
  };
};

export const deleteManufacturerAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_MANUFACTURER,
    data,
    onSuccess,
    onError,
  };
};
export const ManufacturerImportAction = (data, onSuccess, onError) => {
  return {
    type: MANUFACTURERS_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

/***Tax Setup */

export const taxTypeListAction = (data, onSuccess, onError) => {
  return {
    type: TAX_TYPE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addTaxTypeAction = (data, onSuccess, onError) => {
  return {
    type: ADD_TAX_TYPE,
    data,
    onSuccess,
    onError,
  };
};

export const updateTaxTypeAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_TAX_TYPE,
    data,
    onSuccess,
    onError,
  };
};

export const deleteTaxTypeAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_TAX_TYPE,
    data,
    onSuccess,
    onError,
  };
};
export const taxTypeImportAction = (data, onSuccess, onError) => {
  return {
    type: TAX_TYPE_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const taxCombinationListAction = (data, onSuccess, onError) => {
  return {
    type: TAX_COMBINATION_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addTaxCombinationAction = (data, onSuccess, onError) => {
  return {
    type: ADD_TAX_COMBINATION,
    data,
    onSuccess,
    onError,
  };
};

export const updateTaxCombinationAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_TAX_COMBINATION,
    data,
    onSuccess,
    onError,
  };
};

export const deleteTaxCombinationAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_TAX_COMBINATION,
    data,
    onSuccess,
    onError,
  };
};

export const deleteTaxCombinationItemAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_TAX_COMBINATION_ITEM,
    data,
    onSuccess,
    onError,
  };
};

export const taxCombinationImportAction = (data, onSuccess, onError) => {
  return {
    type: TAX_COMBINATION_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const taxTypeDropDownAction = (data, onSuccess, onError) => {
  return {
    type: TAX_TYPE_DROPDOWN,
    data,
    onSuccess,
    onError,
  };
};

/**Shipping Type */

export const ShippingTypeTableListAction = (data, onSuccess, onError) => {
  return {
    type: SHIPPING_TYPE_TABLE__LIST,
    data,
    onSuccess,
    onError,
  };
};

export const addShippingTypeAction = (data, onSuccess, onError) => {
  return {
    type: ADD_SHIPPING_TYPE,
    data,
    onSuccess,
    onError,
  };
};

export const updateShippingTypeAction = (data, onSuccess, onError) => {
  return {
    type: UPDATE_SHIPPING_TYPE,
    data,
    onSuccess,
    onError,
  };
};

export const deleteShippingTypeAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_SHIPPING_TYPE,
    data,
    onSuccess,
    onError,
  };
};
export const ShippingTypeImportAction = (data, onSuccess, onError) => {
  return {
    type: SHIPPING_TYPE_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

/**Document Numbering */
export const documentNumberingListAction = (data, onSuccess, onError) => {
  return {
    type: DOCUMENT_NUMBERING_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const documentNumberingUpdateAction = (data, onSuccess, onError) => {
  return {
    type: DOCUMENT_NUMBERING_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const documentNumberingSeriesListAction = (data, onSuccess, onError) => {
  return {
    type: DOCUMENT_NUMBERING_SERIES_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const documentNumberingSeriesAddAction = (data, onSuccess, onError) => {
  return {
    type: DOCUMENT_NUMBERING_SERIES_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const documentNumberingSeriesUpdateAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: DOCUMENT_NUMBERING_SERIES_UPDATE,
    data,
    onSuccess,
    onError,
  };
};
/**Custom Document Numbering */
export const customNumberingListAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_NUMBERING_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customNumberingUpdateAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_NUMBERING_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const customNumberingSeriesListAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_NUMBERING_SERIES_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const customNumberingSeriesAddAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_NUMBERING_SERIES_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const customNumberingSeriesUpdateAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_NUMBERING_SERIES_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Communication Setup */

/**SMTP */
export const smtpViewAction = (data, onSuccess, onError) => {
  return {
    type: SMTP_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const smtpAddAction = (data, onSuccess, onError) => {
  return {
    type: SMTP_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const smtpUpdateAction = (data, onSuccess, onError) => {
  return {
    type: SMTP_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Whatsapp */
export const whatsappViewAction = (data, onSuccess, onError) => {
  return {
    type: WHATSAPP_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const whatsappAddAction = (data, onSuccess, onError) => {
  return {
    type: WHATSAPP_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const whatsappUpdateAction = (data, onSuccess, onError) => {
  return {
    type: WHATSAPP_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const smsViewAction = (data, onSuccess, onError) => {
  return {
    type: SMS_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const smsAddAction = (data, onSuccess, onError) => {
  return {
    type: SMS_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const smsUpdateAction = (data, onSuccess, onError) => {
  return {
    type: SMS_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Payment COnfig */

/**Razor Pay */
export const razorpayViewAction = (data, onSuccess, onError) => {
  return {
    type: RAZORPAY_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const razorpayAddAction = (data, onSuccess, onError) => {
  return {
    type: RAZORPAY_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const razorpayUpdateAction = (data, onSuccess, onError) => {
  return {
    type: RAZORPAY_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Stripe */
export const stripeViewAction = (data, onSuccess, onError) => {
  return {
    type: STRIPE_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const stripeAddAction = (data, onSuccess, onError) => {
  return {
    type: STRIPE_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const stripeUpdateAction = (data, onSuccess, onError) => {
  return {
    type: STRIPE_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Phonepe */
export const phonepeViewAction = (data, onSuccess, onError) => {
  return {
    type: PHONEPE_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const phonepeAddAction = (data, onSuccess, onError) => {
  return {
    type: PHONEPE_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const phonepeUpdateAction = (data, onSuccess, onError) => {
  return {
    type: PHONEPE_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Paytm */
export const paytmViewAction = (data, onSuccess, onError) => {
  return {
    type: PAYTM_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const paytmAddAction = (data, onSuccess, onError) => {
  return {
    type: PAYTM_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const paytmUpdateAction = (data, onSuccess, onError) => {
  return {
    type: PAYTM_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Pine Labs */
export const pineLabsViewAction = (data, onSuccess, onError) => {
  return {
    type: PINE_LABS_VIEW,
    data,
    onSuccess,
    onError,
  };
};

export const pineLabsAddAction = (data, onSuccess, onError) => {
  return {
    type: PINE_LABS_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const pineLabsUpdateAction = (data, onSuccess, onError) => {
  return {
    type: PINE_LABS_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

/**Print Preferences */
export const printPreferenceListAction = (data, onSuccess, onError) => {
  return {
    type: PRINTPREFERENCE_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const printPreferenceUpdateAction = (data, onSuccess, onError) => {
  return {
    type: PRINTPREFERENCE_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const BIllingsTypesAction = (data, onSuccess, onError) => {
  return {
    type: BILLING_TYPES,
    data,
    onSuccess,
    onError,
  };
};

export const currentPrintPreferenceAction = (data, onSuccess, onError) => {
  return {
    type: CURRENT_PRINTPREFERENCE,
    data,
    onSuccess,
    onError,
  };
};

export const storeDetailsUpdateAction = (data, onSuccess, onError) => {
  return {
    type: STORE_UPDATE,
    data,
    onSuccess,
    onError,
  };
};
export const storeDetailsGetAction = (data, onSuccess, onError) => {
  return {
    type: STORE_GET,
    data,
    onSuccess,
    onError,
  };
};

export const mapAlternativerItemAction = (data, onSuccess, onError) => {
  return {
    type: MAP_ALTERNATIVE_ITEM,
    data,
    onSuccess,
    onError,
  };
};
export const alternativeItemsListAction = (data, onSuccess, onError) => {
  return {
    type: ALTERNATIVE_ITEMS_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const deleteAlternativeTransAction = (data, onSuccess, onError) => {
  return {
    type: DELETE_ALTERNATIVE_TRANSACTION,
    data,
    onSuccess,
    onError,
  };
};
export const alternativeItemsImportAction = (data, onSuccess, onError) => {
  return {
    type: ALTERNATIVE_ITEMS_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const addCustomInvoice = (data, onSuccess, onError) => {
  return {
    type: ADD_CUSTOM_INVOICE,
    data,
    onSuccess,
    onError,
  };
};

/* ===============================================================================================*/
/* TCS TAX */

export const tcsTaxListAction = (data, onSuccess, onError) => {
  return {
    type: TCS_TAX_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const tcsTaxCreateAction = (data, onSuccess, onError) => {
  return {
    type: TCS_TAX_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const tcsTaxDeleteAction = (data, onSuccess, onError) => {
  return {
    type: TCS_TAX_DELETE,
    data,
    onSuccess,
    onError,
  };
};
export const tcsTaxImportAction = (data, onSuccess, onError) => {
  return {
    type: TCS_TAX_IMPORT,
    data,
    onSuccess,
    onError,
  };
};
export const tdsTaxListAction = (data, onSuccess, onError) => {
  return {
    type: TDS_TAX_LIST,
    data,
    onSuccess,
    onError,
  };
};
export const partyListAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const tdsTaxCreateAction = (data, onSuccess, onError) => {
  return {
    type: TDS_TAX_ADD,
    data,
    onSuccess,
    onError,
  };
};

export const tdsTaxDeleteAction = (data, onSuccess, onError) => {
  return {
    type: TDS_TAX_DELETE,
    data,
    onSuccess,
    onError,
  };
};
export const tdsTaxImportAction = (data, onSuccess, onError) => {
  return {
    type: TDS_TAX_IMPORT,
    data,
    onSuccess,
    onError,
  };
};

export const templateCreateAction = (data, onSuccess, onError) => {
  return {
    type: TEMPLATE_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const templateTableAction = (data, onSuccess, onError) => {
  return {
    type: TEMPLATE_TABLE,
    data,
    onSuccess,
    onError,
  };
};

export const templateViewAction = (data, onSuccess, onError) => {
  return {
    type: TEMPLATE_VIEW,
    data,
    onSuccess,
    onError,
  };
};
export const templateEditAction = (data, onSuccess, onError) => {
  return {
    type: TEMPLATE_EDIT,
    data,
    onSuccess,
    onError,
  };
};
export const templateDeleteAction = (data, onSuccess, onError) => {
  return {
    type: TEMPLATE_DELETE,
    data,
    onSuccess,
    onError,
  };
};

/* ===============================================================================================*/
/* ROLE AND DEPARTMENT */

export const roleSearchListAction = (data, onSuccess, onError) => {
  return {
    type: ROLE_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const roleCreateAction = (data, onSuccess, onError) => {
  return {
    type: ROLE_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const roleDeleteAction = (data, onSuccess, onError) => {
  return {
    type: ROLE_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const roleEditAction = (data, onSuccess, onError) => {
  return {
    type: ROLE_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const roleDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: ROLE_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

export const departmentListAction = (data, onSuccess, onError) => {
  return {
    type: DEPARTMENR_LIST,
    data,
    onSuccess,
    onError,
  };
};

export const departmentCreateAction = (data, onSuccess, onError) => {
  return {
    type: DEPARTMENT_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const departmentSearchListAction = (data, onSuccess, onError) => {
  return {
    type: DEPARTMENT_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const departmentDeleteAction = (data, onSuccess, onError) => {
  return {
    type: DEPARTMENT_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const departmentEditAction = (data, onSuccess, onError) => {
  return {
    type: DEPARTMENT_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const departmentDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: DEPARTMENT_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

export const attachedRolesDepartmentCreateAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: ATTACHED_ROLES_DEPARTMENT_CREATE,
    data,
    onSuccess,
    onError,
  };
};
export const attachedRolesDepartmentDeleteAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: ATTACHED_ROLES_DEPARTMENT_DELETE,
    data,
    onSuccess,
    onError,
  };
};
//
// DATA SETUP

export const drugSearchListAction = (data, onSuccess, onError) => {
  return {
    type: DRUG_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const drugCreateAction = (data, onSuccess, onError) => {
  return {
    type: DRUG_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const drugDeleteAction = (data, onSuccess, onError) => {
  return {
    type: DRUG_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const drugEditAction = (data, onSuccess, onError) => {
  return {
    type: DRUG_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const drugDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: DRUG_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
//GENERIC
export const genericSearchListAction = (data, onSuccess, onError) => {
  return {
    type: GENERIC_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const genericCreateAction = (data, onSuccess, onError) => {
  return {
    type: GENERIC_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const genericDeleteAction = (data, onSuccess, onError) => {
  return {
    type: GENERIC_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const genericEditAction = (data, onSuccess, onError) => {
  return {
    type: GENERIC_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const genericDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: GENERIC_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
//GENERIC

//COMPOSITION
export const compositionSearchListAction = (data, onSuccess, onError) => {
  return {
    type: COMPOSITION_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const compositionCreateAction = (data, onSuccess, onError) => {
  return {
    type: COMPOSITION_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const compositionDeleteAction = (data, onSuccess, onError) => {
  return {
    type: COMPOSITION_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const compositionEditAction = (data, onSuccess, onError) => {
  return {
    type: COMPOSITION_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const compositionDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: COMPOSITION_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
//COMPOSITION

//LEAD
export const leadSearchListAction = (data, onSuccess, onError) => {
  return {
    type: LEAD_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const leadCreateAction = (data, onSuccess, onError) => {
  return {
    type: LEAD_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const leadDeleteAction = (data, onSuccess, onError) => {
  return {
    type: LEAD_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const leadEditAction = (data, onSuccess, onError) => {
  return {
    type: LEAD_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const leadDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: LEAD_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
//LEAD

//PAYMENT
export const paymentSearchListAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const paymentCreateAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const paymentDeleteAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const paymentEditAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const paymentDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: PAYMENT_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
//PAYMENT

//PACKING
// 📦 Packing Actions
export const packingSearchListAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const packingCreateAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const packingDeleteAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const packingEditAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const packingDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

// 📦 Packing Type Actions
export const packingTypeSearchListAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_TYPE_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const packingTypeCreateAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_TYPE_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const packingTypeDeleteAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_TYPE_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const packingTypeEditAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_TYPE_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const packingTypeDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: PACKING_TYPE_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

// 📦 Carton Actions
export const cartonSearchListAction = (data, onSuccess, onError) => {
  return {
    type: CARTON_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const cartonCreateAction = (data, onSuccess, onError) => {
  return {
    type: CARTON_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const cartonDeleteAction = (data, onSuccess, onError) => {
  return {
    type: CARTON_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const cartonEditAction = (data, onSuccess, onError) => {
  return {
    type: CARTON_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const cartonDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: CARTON_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

//PACKING

//PARTY
export const partySearchListAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const partyCreateAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const partyDeleteAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const partyEditAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const partyDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
// PARTY CATEGORY
export const partyCatogerySearchListAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_CATEGORY_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const partyCatogeryCreateAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_CATEGORY_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const partyCatogeryDeleteAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_CATEGORY_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const partyCatogeryEditAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_CATEGORY_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const partyCatogeryDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_CATEGORY_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
// PARTY CATEGORY
// PARTY GROUP
export const partyGroupSearchListAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_GROUP_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const partyGroupCreateAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_GROUP_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const partyGroupDeleteAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_GROUP_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const partyGroupEditAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_GROUP_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const partyGroupDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: PARTY_GROUP_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
// PARTY GROUP

//LOCATION

// COUNTRY
export const countrySearchListAction = (data, onSuccess, onError) => {
  return {
    type: COUNTRY_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const countryCreateAction = (data, onSuccess, onError) => {
  return {
    type: COUNTRY_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const countryDeleteAction = (data, onSuccess, onError) => {
  return {
    type: COUNTRY_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const countryEditAction = (data, onSuccess, onError) => {
  return {
    type: COUNTRY_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const countryDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: COUNTRY_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

// REGION
export const regionSearchListAction = (data, onSuccess, onError) => {
  return {
    type: REGION_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const regionCreateAction = (data, onSuccess, onError) => {
  return {
    type: REGION_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const regionDeleteAction = (data, onSuccess, onError) => {
  return {
    type: REGION_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const regionEditAction = (data, onSuccess, onError) => {
  return {
    type: REGION_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const regionDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: REGION_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

// STATE
export const stateSearchListAction = (data, onSuccess, onError) => {
  return {
    type: STATE_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const stateCreateAction = (data, onSuccess, onError) => {
  return {
    type: STATE_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const stateDeleteAction = (data, onSuccess, onError) => {
  return {
    type: STATE_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const stateEditAction = (data, onSuccess, onError) => {
  return {
    type: STATE_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const stateDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: STATE_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

// DISTRICT
export const districtSearchListAction = (data, onSuccess, onError) => {
  return {
    type: DISTRICT_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const districtCreateAction = (data, onSuccess, onError) => {
  return {
    type: DISTRICT_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const districtDeleteAction = (data, onSuccess, onError) => {
  return {
    type: DISTRICT_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const districtEditAction = (data, onSuccess, onError) => {
  return {
    type: DISTRICT_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const districtDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: DISTRICT_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

// CITY
export const citySearchListAction = (data, onSuccess, onError) => {
  return {
    type: CITY_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const cityCreateAction = (data, onSuccess, onError) => {
  return {
    type: CITY_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const cityDeleteAction = (data, onSuccess, onError) => {
  return {
    type: CITY_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const cityEditAction = (data, onSuccess, onError) => {
  return {
    type: CITY_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const cityDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: CITY_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

// AREA
export const areaSearchListAction = (data, onSuccess, onError) => {
  return {
    type: AREA_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const areaCreateAction = (data, onSuccess, onError) => {
  return {
    type: AREA_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const areaDeleteAction = (data, onSuccess, onError) => {
  return {
    type: AREA_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const areaEditAction = (data, onSuccess, onError) => {
  return {
    type: AREA_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const areaDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: AREA_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

//LOCATION

//SERVER
export const serverSearchListAction = (data, onSuccess, onError) => {
  return {
    type: SERVER_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const serverCreateAction = (data, onSuccess, onError) => {
  return {
    type: SERVER_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const serverDeleteAction = (data, onSuccess, onError) => {
  return {
    type: SERVER_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const serverEditAction = (data, onSuccess, onError) => {
  return {
    type: SERVER_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const serverDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: SERVER_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

//SERVER

//SPECILIZATION
export const specializationSearchListAction = (data, onSuccess, onError) => {
  return {
    type: SPECIALIZATION_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const specializationCreateAction = (data, onSuccess, onError) => {
  return {
    type: SPECIALIZATION_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const specializationDeleteAction = (data, onSuccess, onError) => {
  return {
    type: SPECIALIZATION_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const specializationEditAction = (data, onSuccess, onError) => {
  return {
    type: SPECIALIZATION_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const specializationDocumentUploadAction = (
  data,
  onSuccess,
  onError
) => {
  return {
    type: SPECIALIZATION_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};

//SPECILIZATION

//SUB-SECP
export const subSpecialSearchListAction = (data, onSuccess, onError) => {
  return {
    type: SUB_SPECIAL_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const subSpecialCreateAction = (data, onSuccess, onError) => {
  return {
    type: SUB_SPECIAL_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const subSpecialDeleteAction = (data, onSuccess, onError) => {
  return {
    type: SUB_SPECIAL_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const subSpecialEditAction = (data, onSuccess, onError) => {
  return {
    type: SUB_SPECIAL_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const subSpecialDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: SUB_SPECIAL_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
//SUB-SECP

//INSURANCE
export const insuranceSearchListAction = (data, onSuccess, onError) => {
  return {
    type: INSURANCE_SEARCH,
    data,
    onSuccess,
    onError,
  };
};

export const insuranceCreateAction = (data, onSuccess, onError) => {
  return {
    type: INSURANCE_CREATE,
    data,
    onSuccess,
    onError,
  };
};

export const insuranceDeleteAction = (data, onSuccess, onError) => {
  return {
    type: INSURANCE_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const insuranceEditAction = (data, onSuccess, onError) => {
  return {
    type: INSURANCE_EDIT,
    data,
    onSuccess,
    onError,
  };
};

export const insuranceDocumentUploadAction = (data, onSuccess, onError) => {
  return {
    type: INSURANCE_UPLOAD,
    data,
    onSuccess,
    onError,
  };
};
//INSURANCE

// DATA SETUP

export const MODULE_SETTINGS_GET_ALL = "MODULE_SETTINGS_GET_ALL";
export const MODULE_SETTINGS_UPDATE = "MODULE_SETTINGS_UPDATE";

export const moduleSettingsGetAllAction = (onSuccess, onError) => ({
  type: MODULE_SETTINGS_GET_ALL,
  onSuccess,
  onError,
});

export const moduleSettingsUpdateAction = (data, onSuccess, onError) => ({
  type: MODULE_SETTINGS_UPDATE,
  data,
  onSuccess,
  onError,
});
